import React from 'react';
import styled from 'styled-components';
import { DataAmount } from '@toqio/toqio-web-components';
import type { Card } from '../types';
import { CARD_BALANCE_GREY, MOBILE } from './styles';

/**
 * Card available balance, rendered with the DS `DataAmount` (PRD §5 / MAPPINGS
 * → Data amount). The bespoke type scale and the SUSPENDED grey are reproduced
 * from the source CSS by overriding the DS value/currency classes — value is
 * 30/38 on mobile (carousel) and 24/32 on desktop (grid), currency is the
 * secondary-font grey.
 */
const Wrap = styled.div<{ $suspended: boolean }>`
  .toqio-data-amount-value {
    font-size: 30px;
    line-height: 38px;
    ${({ $suspended }) => ($suspended ? `color: ${CARD_BALANCE_GREY};` : '')}
    @media (min-width: ${MOBILE}) {
      font-size: 24px;
      line-height: 32px;
    }
  }
  .toqio-data-amount-currency {
    color: ${CARD_BALANCE_GREY};
    font-size: 14px;
    line-height: 20px;
  }
`;

export const Balance: React.FC<{ card: Card }> = ({ card }) => (
  <Wrap $suspended={card.status === 'SUSPENDED'}>
    <DataAmount
      label=""
      value={card.formattedBalance}
      currency={card.currency}
      size="m"
      weight="bold"
    />
  </Wrap>
);
